import React from 'react';
import { Box, Button } from '@mui/material';

const Toolbar = ({onAddLayer, onSaveCanvas}) => {
    return (
        <Box sx={{ marginBottom: '16px' }}>
            <Button variant="contained" onClick={() => onAddLayer('image')} sx={{ marginRight: '8px' }}>Add Image</Button>
            <Button variant="contained" onClick={() => onAddLayer('text')} sx={{ marginRight: '8px' }}>Add Text</Button>
            <Button variant="contained" onClick={onSaveCanvas}>Save</Button>
        </Box>
    );
};

export default Toolbar;